export function InstanceDetailPage() {
  return <div>Instance Detail Page </div>;
}
